module.exports = "<span ng-message=pattern> *Must be a valid zip containing only numbers or common characters (\"-\") </span>";